{#if $observationData}
  <div class="tab-pane show active" role="tabpanel">
    <div class="d-flex justify-content-between mb-4">
      <div class="d-flex flex-column">
        <p class="muted mb-1">
          {$observationData.dateByName}, {#if $curretDay}
            {$observationData.time}
          {:else}
            {$observationData.dateSLO}
          {/if}
        </p>
        <p class="muted mb-1">{$selectedCity["city"]}</p>
        {#if $curretDay}
          <h1>{$observationData.icon_text_capitalized}</h1>
        {:else}
          <h1>{$mobileCurrentCityObservationData.icon_text}</h1>
        {/if}
        <p class="muted m-0 mt-auto small">
          {$observationData.sunriseHour}

          <svg
            style="height: 1.4em; margin: 0 .3em;"
            xmlns="http://www.w3.org/2000/svg"
            xml:space="preserve"
            viewBox="0 0 100 66"
            ><path
              fill="currentColor"
              d="M50 26.3c1.5 0 2.8-1.2 2.8-2.6V2.6C52.8 1.2 51.5 0 50 0c-1.5 0-2.8 1.2-2.8 2.6v21.1c0 1.5 1.3 2.6 2.8 2.6zM18.4 37.2a3 3 0 0 0 2 .8c.7 0 1.4-.3 2-.8 1.1-1 1.1-2.7 0-3.7L10.2 21.9c-1.1-1-2.9-1-3.9 0a2.5 2.5 0 0 0 0 3.7l12.1 11.6zm78.8 23.5H83.3a32.8 32.8 0 0 0-33.3-29 32.9 32.9 0 0 0-33.3 29H2.8c-1.5 0-2.8 1.2-2.8 2.6S1.2 66 2.8 66H97c1.5 0 2.8-1.2 2.8-2.6s-1-2.7-2.6-2.7zM79.6 38c.7 0 1.4-.3 2-.8l12.2-11.5c1.1-1 1.1-2.7 0-3.7s-2.9-1-3.9 0L77.6 33.5a2.5 2.5 0 0 0 0 3.7c.5.5 1.2.8 2 .8z"
            ></path></svg
          >

          {$observationData.sunsetHour}
        </p>
      </div>
      <div>
        {#if $curretDay}
          <img
            class="weather-icon"
            style="width: 100px;"
            src="https://img.rtvslo.si/_static/novi/bootstrap/public/img/weather-widget/{displayIconObservation}.svg"
            alt="{$observationData.icon_text}"
          />
        {:else}
          <img
            class="weather-icon"
            style="width: 100px;"
            src="https://img.rtvslo.si/_static/novi/bootstrap/public/img/weather-widget/{displayIconMobile}.svg"
            alt="{$mobileCurrentCityObservationData.icon_text}"
          />
        {/if}
        <div class="h1 font-weight-bold text-center" style="line-height: 1;">
          {#if $curretDay}
            {$observationData.temperature}°
          {:else}
            <span>{$mobileCurrentCityObservationData.maxTemp}°</span> <br />
            <span class="font-weight-light muted"
              >{$mobileCurrentCityObservationData.minTemp}°</span
            >
          {/if}
        </div>
      </div>
    </div>
  </div>
{/if}

<script lang="ts">
  import { weatherStore } from "../store";
  const {
    selectedCity,
    observationData,
    curretDay,
    mobileCurrentCityObservationData,
  } = weatherStore;
  import { iconConverter } from "./../services/IconConverter";
  import MarkerHolder from "./MarkerHolder.svelte";
  import { utils } from "../services/Utils";

  let displayIconObservation = "";
  let displayIconMobile = "";

  $: if ($observationData) {
    displayIconObservation = utils.getDisplayIcon(
      $observationData.icon,
      $observationData.time,
      $observationData.sunriseHour,
      $observationData.sunsetHour,
    );

    const mobileData = $mobileCurrentCityObservationData as any;
    if (mobileData && mobileData.icon) {
      // mobileData might use different time properties?
      // It's "Forecast" data? Or another city observation?
      // Assuming it follows similar structure or we use same time context?
      // If it is another city, it has its own time/sunrise/sunset.
      // In store.ts: mobileCurrentCityObservationData seems to be set from currentObservationData
      // It should have sunriseHour/sunsetHour if mapped correctly.
      // Let's assume mobileData has sunriseHour/sunsetHour
      displayIconMobile = utils.getDisplayIcon(
        mobileData.icon,
        mobileData.time,
        mobileData.sunriseHour,
        mobileData.sunsetHour,
      );
    }
  }
</script>
